import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, Invoice, PropertyInvoice } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';

export async function getInvoice(id: number) {
    const response = await getBFFApiClient().get<APIResponse<Invoice>>(
        `/v1/invoice/${id}`
    );

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error('Failed to get overdue invoices');
    }

    return response.data.data;
}

export async function getPropertyInvoices(propertyId: string | number) {
    const response = await getBFFApiClient().get<APIResponse<PropertyInvoice[]>>(`/v1/property/${propertyId}/invoices`);

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get invoices: ${response.data.error}`);
    }

    return response.data.data;
}

export async function uploadInvoiceToIntegration(id: number) {
    const response = await getBFFApiClient().post<APIResponse<Invoice>>(
        `/v1/invoice/${id}/upload`
    );

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to upload invoice');
    }

    return response.data.data;
}

export async function forwardInvoice(
    id: number,
    toAddresses: string[],
    ccAddresses: string[],
    message: string | null
) {
    const response = await getBFFApiClient().post<APIResponse<null>>(`/v1/invoice/${id}/forward`, {
        toAddresses,
        ccAddresses,
        message,
    });

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to forward invoice');
    }

    return response.data.data;
}

export async function getInvoicePdfUrl(id: number) {
    const response = await getBFFApiClient().post<APIResponse<Invoice>>(
        `/v1/invoice/${id}/pdf`
    );

    if (!response.data.success) {
        throw new Error(response.data.error);
    }

    if (response.status !== HttpStatusCodes.OK) {
        throw new Error('Failed to get invoice PDF url');
    }

    return response.data.data;
}
